export default __webpack_public_path__ + "static/media/college_app_icon.3f30fdc8.png";